import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from './firebase';

export function investmentCaseDeckStoragePath(userId: string, caseId: string): string {
  return `investmentCaseDecks/${userId}/${caseId}.pdf`;
}

export async function uploadInvestmentCaseDeck(
  userId: string,
  caseId: string,
  file: File
): Promise<{ deckPdfUrl: string; deckPdfStoragePath: string }> {
  const deckPdfStoragePath = investmentCaseDeckStoragePath(userId, caseId);
  const r = ref(storage, deckPdfStoragePath);
  await uploadBytes(r, file, { contentType: file.type || 'application/pdf' });
  const deckPdfUrl = await getDownloadURL(r);
  return { deckPdfUrl, deckPdfStoragePath };
}

export async function deleteInvestmentCaseDeck(deckPdfStoragePath: string | undefined): Promise<void> {
  if (!deckPdfStoragePath) return;
  try {
    await deleteObject(ref(storage, deckPdfStoragePath));
  } catch {
    /* ignore missing object */
  }
}
